




export default
  name: 'ManageSubTitle'

  components: {
  }

  props:
    label:
      type: String
      default: ''
    paddingTop:
      type: Boolean
      default: false
